import classNames from 'classnames';
import { Dropdown, Menu, MenuItem, Popover, Radio } from 'components-antd';

import styles from './styles.module.scss';
import { ArrowDown } from 'components/Icons';
import { ICON_VARIANT_TYPE, Icons } from 'pages/FormProcess/Icons';

export const FormRolesDropdown = ({ formRoles, onSelectRole }) => {
  const menu = (
    <Radio.Group className={styles.optionsItems}>
      <Menu>
        {formRoles.map((item, index) => (
          <MenuItem
            key={index}
            onClick={(e) => {
              onSelectRole(index);
            }}
          >
            <div className={styles.option}>
              <span
                style={{
                  backgroundColor: item.color,
                }}
                className={styles.userColorBox}
              />
              <span className={styles.optionValue}>{item.Name}</span>
            </div>
          </MenuItem>
        ))}
      </Menu>
    </Radio.Group>
  );

  return (
    <div className={classNames(styles.rolesDropdownWrapper)}>
      <Dropdown
        overlay={menu}
        placement="bottomLeft"
        getPopupContainer={(triggerNode) => triggerNode}
        trigger={['click']}
        overlayClassName={styles.formRolesDropdown}
      >
        <a
          onClick={(e) => e.preventDefault()}
          className={classNames(styles.roleDropdownItem, 'mosaikDropdownButton')}
        >
          <span>More</span>
          <Icons
            variant={ICON_VARIANT_TYPE.DropdownArrow}
            className={classNames(styles.icon, { [styles.open]: open })}
          />
        </a>
      </Dropdown>
    </div>
  );
};
